class Sesiones{
    sesiones;

    constructor( conf ){
        this.sesiones= []
        let inicio= this.timeToInt( conf.inicio )
        for (let i=0; i< conf.contador; i++){
            this.sesiones.push({
                inicio: inicio,
                id: this.intToTime( inicio )
            })
            inicio= inicio + conf.duracion
        }
    }


    intToTime( minutos ){
        let horas= Math.floor( minutos / 60)
        horas= horas % 24
        minutos= minutos % 60
        return horas.toString().padStart(2,0) + ":" + minutos.toString().padStart(2,0)

    }

    timeToInt( time ){
        let [horas, minutos]= time.split(':')
        return parseInt(horas) * 60 + parseInt(minutos)
    }

}

export default Sesiones